var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandiProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 3.25,
    fill: "#84E1CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5C14.0609 5 15.0783 5.42143 15.8284 6.17157C16.5786 6.92172 17 7.93913 17 9C17 10.0609 16.5786 11.0783 15.8284 11.8284C15.0783 12.5786 14.0609 13 13 13C11.9391 13 10.9217 12.5786 10.1716 11.8284C9.42143 11.0783 9 10.0609 9 9C9 7.93913 9.42143 6.92172 10.1716 6.17157C10.9217 5.42143 11.9391 5 13 5ZM13 15C17.42 15 21 16.79 21 19V21H5V19C5 16.79 8.58 15 13 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandiProfile);
export default __webpack_public_path__ + "static/media/candiProfile.b0f6493e33c6ce572a32ba8b3f949381.svg";
export { ForwardRef as ReactComponent };